import { createSelector } from 'reselect'

export const selectCacheState = state => state.cacheTools

export const selectCacheStoreData = createSelector(selectCacheState, data => ({
  cacheKey: data.cacheKey,
  value: data.value,
  isEmpty: Boolean(data.isEmpty),
  isSearching: Boolean(data.isSearching),
  error: data.error,
}))
